import { render, staticRenderFns } from "./AdminSubCategory.vue?vue&type=template&id=34ac79a4&scoped=true&"
import script from "./AdminSubCategory.vue?vue&type=script&lang=js&"
export * from "./AdminSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubCategory.vue?vue&type=style&index=0&id=34ac79a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac79a4",
  null
  
)

export default component.exports